const MissionStatement = () => {
    return (
      <div className="container mx-auto py-16 px-6 text-center">
        <h2 className="text-3xl font-bold text-gray-800">Our Mission</h2>
        <p className="mt-4 text-lg text-gray-600">
          At Motor Bike BD, we strive to provide the best motorbikes and accessories for enthusiasts who live for the thrill of the road. Our goal is to fuel your passion for riding with quality products, exceptional service, and a community of like-minded riders.
        </p>
      </div>
    );
  };
  
  export default MissionStatement